module.exports = __webpack_public_path__ + "img/slide-2.a231387d.jpg";